import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { formatMapCountryName } from "@/views/home/maptiler/formatMapCountryName";

export function useMapCountryGroupsFilter(props, emit) {
  const { t, locale } = useI18n();
  const innerKeyword = ref(props.keyword);

  watch(
    () => props.keyword,
    (v) => {
      innerKeyword.value = v;
    }
  );

  watch(innerKeyword, (v) => emit("update:keyword", v));

  const onClearKeyword = () => {
    innerKeyword.value = "";
    emit("update:keyword", "");
  };

  const mapCountryGroup = (country) => ({
    ...country,
    countryName: formatMapCountryName(country.countryName, t),
  });

  const filterProvinces = (country, kw) =>
    (country.provinces || [])
      .map((province) => {
        const provinceName = String(province.provinceName || "").toLowerCase();
        const provinceMatched = provinceName.includes(kw);
        const dealers = provinceMatched
          ? province.dealers || []
          : (province.dealers || []).filter((item) => {
              const text = [
                item.fullName,
                item.address,
                item.fullAddress,
                item.provinceName,
                item.countryName,
              ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();
              return text.includes(kw);
            });
        return { ...province, dealers };
      })
      .filter((province) => province.dealers.length > 0);

  const filteredGroups = computed(() => {
    void locale.value;
    const kw = String(innerKeyword.value || "")
      .trim()
      .toLowerCase();
    if (!kw) return (props.groups || []).map(mapCountryGroup);

    return (props.groups || [])
      .map((country) => ({
        ...mapCountryGroup(country),
        provinces: filterProvinces(country, kw),
      }))
      .filter((country) => country.provinces.length > 0);
  });

  const totalCount = computed(() =>
    (props.groups || []).reduce(
      (sum, country) =>
        sum +
        (country.provinces || []).reduce(
          (pSum, province) => pSum + (province.dealers || []).length,
          0
        ),
      0
    )
  );

  return {
    innerKeyword,
    filteredGroups,
    totalCount,
    onClearKeyword,
  };
}
